<template>
  <div class="w-full flex justify-center pb-12">
    <div class="relative text-center">
      <p class="text-3xl text-gray-600 font-medium">
        {{ __('label_giftcards') }}
      </p>

      <p class="text-xl text-gray-500 font-medium pt-8">
        {{ __('label_giftcards_redeem') }}
      </p>
    </div>
  </div>

  <div class="flex justify-center">
    <div class="w-2/3">
      <div
        class="grid space-x-4 gap-y-4"
        :class="gridColsClass"
      >
        <div
          v-for="(brand, index) in config.body?.giftcards ?? []"
          :key="index"
          class="flex justify-center"
        >
          <img
            v-if="brand.logo_url ?? false"
            class="h-32 w-32 object-contain"
            :src="brand.logo_url"
            alt="Logo"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
});

const gridColsClass = ref([
  'grid-cols-1',
  'grid-cols-2',
  'grid-cols-2 sm:grid-cols-3',
  'grid-cols-2 sm:grid-cols-4',
][props.config.body?.giftcards_columns - 1] ?? 'grid-cols-4');
</script>
